import { Box, Grid, Stack, Title } from '@mantine/core';

import { Importer } from '@e-origin/shared';

import { DatePickerInput, TextInput } from '@components';

interface ImporterViewGeneralInfoProps {
  importer: Importer;
}

export const ImporterViewGeneralInfo: React.FC<ImporterViewGeneralInfoProps> = ({ importer }) => {
  return (
    <Box>
      <Stack gap={20} pt={40} pb={0}>
        <Title order={4}>ID Card</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={importer?.idCard.ownerName} label="Owner name" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <DatePickerInput label="Expiration Date" value={new Date(importer?.idCard.expirationDate || null)} disabled />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap={20} pt={40} pb={0}>
        <Title order={4}>Chinese business license</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={importer?.businessLicense.nameEN} label="Company name EN" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={importer?.businessLicense.nameCN} label="Company name CN" disabled />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={6}>
            <TextInput value={importer?.idCard.ownerName} label="Owner name" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={importer?.businessLicense.registrationNumber} label="Registration number" disabled />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap={20} pt={40} pb={0}>
        <Title order={4}>EORI importer</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={importer?.businessLicense.nameEN} label="Company name EN" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={importer?.eori.number} label="EORI number" disabled />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={3}>
            <TextInput value={importer?.eori.address.street} label="Street & number" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={importer?.eori.address.city} label="City" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={importer?.eori.address.zipCode} label="Zip code" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={importer?.eori.address.country} label="Country" disabled />
          </Grid.Col>
        </Grid>
      </Stack>

      <Stack gap={20} pt={40} pb={0}>
        <Title order={4}>VAT importer</Title>
        <Grid>
          <Grid.Col span={6}>
            <TextInput value={importer?.businessLicense.nameEN} label="Company name EN" disabled />
          </Grid.Col>

          <Grid.Col span={6}>
            <TextInput value={importer?.vat.number} label="VAT importer" disabled />
          </Grid.Col>
        </Grid>

        <Grid>
          <Grid.Col span={3}>
            <TextInput value={importer?.vat.address.street} label="Street & number" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={importer?.vat.address.city} label="City" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={importer?.vat.address.zipCode} label="Zip code" disabled />
          </Grid.Col>

          <Grid.Col span={3}>
            <TextInput value={importer?.vat.address.country} label="Country" disabled />
          </Grid.Col>
        </Grid>
      </Stack>
    </Box>
  );
};
